import { render, staticRenderFns } from "./offsetRecords.vue?vue&type=template&id=5899122e&scoped=true&"
import script from "./offsetRecords.vue?vue&type=script&lang=js&"
export * from "./offsetRecords.vue?vue&type=script&lang=js&"
import style0 from "./offsetRecords.vue?vue&type=style&index=0&id=5899122e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5899122e",
  null
  
)

component.options.__file = "offsetRecords.vue"
export default component.exports